import axios from "axios";
import config from "../config";

const https = require('https');

const agent = new https.Agent({
    rejectUnauthorized: false,
});

const instance = axios.create({
    baseURL: config.WS_BASE_URL,
});

instance.interceptors.request.use(async(config) => {
    config.httpsAgent = agent
    const token = localStorage.getItem("token");
    config.headers.Authorization = token ? token : "";
    config.headers.ContentType = "application/json";
    return config;
});

export const getAll = async(userID) =>
    await instance.post("users/all", { userID });

export const deleteUser = async(userID) =>
    await instance.post("users/delete", { userID });

export const register = async(name, email, password, phone, agency, role) =>
    await instance.post("users/register", {name,email,password,phone,agency,role,});

export const newUser = async(name, email, password,  role, cardID) =>
    await instance.post("users/new/user", {name,email,password,role, cardID});

export const confirmRegister = async(id) =>
    await instance.post(`users/confirm/${id}`);

export const forgotPassword = async(email) =>
    await instance.post("users/forgotpassword", { email });

export const confirmReset = async(id, password) =>
    await instance.post(`users/resetpass/${id}`, { password });

export const login = async(email, password) =>
    await instance.post("users/login", { email, password });

export const newPass = async(id, password) =>
    await instance.post("users/newpass", { id, password });

export const logout = async(token) =>
    await instance.post("users/logout", { token });

export const edit = async(userID,name,email,phone,birthday,adress,country,facebook,instagram,position,sDate,eDate,exp,about) =>
    await instance.post("/users/edit", {
        userID,
        name,
        email,
        phone,
        birthday,
        adress,
        country,
        facebook,
        instagram,
        position,
        sDate,
        eDate,
        exp,
        about,
    });

export const editt = async(formData) =>
    await instance.post("/users/editt", formData);

export const getProfileInfo = async(userID) =>
    await instance.post("/users/getinfo", { userID });

/*
export const jobReg = async (name, email, pass, phone, birthday, adress, country, facebook, instagram,
position, sDate, eDate, exp, about, formData) =>
console.log(formData)
//await instance.post("/users/jobreg", { name, email, pass, phone, birthday, adress, country, facebook, instagram,
  //  position, sDate, eDate, exp, about, formData });
*/

export const jobReg = async(formData) =>
    await instance.post("/users/jobreg", formData);

export const sendMailNextFase = async(userID, email, name) =>
    await instance.post('/users/nextfase', { userID, email, name });

export const userFiles = async(files) =>
    await instance.post('/users/files', files);

export const savePrivateInfo = async({userID, rate, rate2, notes, payrate, active,  role,house,manager, cardID}) =>
    await instance.post('/users/privateInfo', { userID, rate, rate2, notes, payrate, active,  role,house,manager, cardID })

export const checkAndRole = async(id,role) =>
    await instance.post('/users/checksession',{id,role});

export const getDocs = async(email) =>
    await instance.post('/users/getdocs', { email })

export const usersByRole = async(role) =>
    await instance.post('/users/byrole', {role});

    //Schedule routes

export const getScheduleSettings = async() =>
    await instance.post('/schedule/getsettings');

export const getScheduleEvents = async() =>
    await instance.post('/schedule/getevents');

export const clockInOutAPI = async(data, user) =>
    await instance.post('/schedule/clockinout', { data, user });

export const getPayroll = async(sDate) =>
    await instance.post('/schedule/payroll', { sDate })

export const getIcal = async() =>
    await instance.post('/schedule/geticall')

export const openDoorAPI = async() =>
    await instance.post('/users/opendoor')

export const getClosedDays = async() =>
    await instance.post('/users/posclose')

export const allUsersSelect = async() =>
    await instance.post('/users/select/all')

export const updatePayrate = async(userId,payrate) =>
    await instance.post('/users/update/payrate',{userId,payrate})

export const updateContract = async(userId,payrate) =>
    await instance.post('/users/update/contract',{userId,payrate})
    
export const submitVideo = async(data) =>
    await instance.post('/users/nextfase/video',data)

export const tester = async() =>
    await instance.post('/');